export enum UserSteps {
  DOCUMENT = 1,
  PERSONAL_DATA = 2,
  ADDRESS = 3,
  PIN = 4,
  LIVENESS = 5,
}

export enum AccountSteps {
  COMPANY_DATA = 1,
  DOCUMENTS = 2,
  ADDRESS = 3,
}

export enum TwofaMethodEnum {
  SMS = 1,
  EMAIL = 2,
}

export enum OperatorInviteStatus {
  INACTIVE = 0,
  ACTIVE = 1,
  GUEST = 2,
}

export enum SharingUserStatusEnum {
  ACTIVE = 1,
  INVITED = 2,
  INACTIVE = 3,
  CANCELED = 4,
}
